import { useContext } from 'react';

import { AuthorizedAxiosContext } from './index';

export function useAuthorizedAxios() {
  return useContext(AuthorizedAxiosContext);
}
